import {PaymentEntityTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function paymentEntityTypeNameFilter(type: PaymentEntityTypeEnum): string {
  switch (type) {
    case PaymentEntityTypeEnum.Common: return i18n.t(LF.CommonPaymentType) as string;
    case PaymentEntityTypeEnum.Advance: return i18n.t(LF.AdvancePaymentType) as string;
    case PaymentEntityTypeEnum.B2B: return 'B2B';
    default: return '' as string;
  }
}
